import { Amplify } from 'aws-amplify';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';

import 'src/shared/i18n';

import { AppProvider } from '@/shared/app/provider/provider';
import { amplifyConfiguration } from '@/shared/aws-export';
import { GlobalStyle } from '@/shared/components/ui/global-style/global-style.styled';
import { Toast } from '@/shared/components/ui/toast/toast';
import { AppThemeProvider } from '@/shared/features/theme-switcher/context/theme-context';
import { useAuthListener } from '@/shared/hooks/use-auth-listener/use-auth-listener';
import store from '@/shared/redux/store/store';

import { AppRouter } from './router';

Amplify.configure(
  amplifyConfiguration({
    userPoolId: import.meta.env.VITE_APP_AWS_USER_POOLS_ID,
    userPoolClientId: import.meta.env.VITE_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  }),
);

export const App = () => {
  useAuthListener();

  return (
    <Provider store={store}>
      <AppThemeProvider>
        <GlobalStyle />
        <Toast />
        <AppProvider>
          <AppRouter />
        </AppProvider>
      </AppThemeProvider>
    </Provider>
  );
};
